<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseEmailModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}"
    >
      <b-form @submit.prevent="handleSubmit(submitValidatedEmailLocal)">
        <email-form
            :email="emailLocal"
            :formErrors="errors"
            :is-template="isTemplate"
        />
        <button
            ref="submitEmailFormRef"
            class="d-none"
        ></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver }   from 'vee-validate'
import { capitalize }           from '../../utils/filter'

import useAPI      from '../../utils/useAPI'
import { clone }   from '../../utils/utils'
import EmailForm   from '../form/email/EmailForm.vue'

export default {
  components: {
    EmailForm,
    ValidationObserver
  },
  props: {
    email: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    emailModalDefaultTab: {
      type: String,
      default :null
    },
    isTemplate: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const emailLocal = ref(props.email)
    const submitEmailFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(emailLocal, (val) => {
      emit('update:email', val)
    })
    // watch(emailLocal, (val) => {
    //   console.log(val)
    // }, {deep: true})

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseEmailModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitEmailFormRef.value.click()
      }
    }

    const submitValidatedEmailLocal = () => {
      emit('submitValidated')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedEmailLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      emailLocal,
      submitEmailFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseEmailModal,
      submitValidatedEmailLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    email: function (val) {
      this.emailLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>